import {AssetModel, AssetTypeModel, DtoAssetInterface, DtoAssetTypeRequestInterface} from "../interfaces";
import {mapAssetTypeTranslationToDtoArray} from "./asset-type-translation.mapping";
import {mapMediaInfoFromDtoArray} from "./media-info.mappings";

export const mapAssetFromDto = (dto: DtoAssetInterface): AssetModel => {
  return {
    customerOrgId: dto.customerOrgId,
    assetId: dto.assetId,
    rootAssetId: dto.rootAssetId,
    customerOrg: dto.customerOrg,
    customerOrgAg: dto.customerOrgAg,
    customerOrgWe: dto.customerOrgWe,
    assetName: dto.assetName,
    assetTypeName: dto.assetTypeName,
    equipmentNameSap: dto.equipmentNameSap,
    equipmentNameSis: dto.equipmentNameSis,
    assetType: dto.assetType,
    lockStatus: dto.lockStatus,
    technology: dto.technology,
    serialNo: dto.serialNo,
    manufacturerSerialNo: dto.manufacturerSerialNo,
    materialNumberProduction: dto.materialNumberProduction,
    productHierarchyNumber: dto.productHierarchyNumber,
    machineGroupCodeSis: dto.machineGroupCodeSis,
    automationDegree: dto.automationDegree,
    businessUnitSis: dto.businessUnitSis,
    subsidiarySis: dto.subsidiarySis,
    equipmentDates: dto.equipmentDates,
    orderFullfillmentDates: dto.equipmentDates?.orderFullfillmentDates,
    functionalLocation: dto.functionalLocation,
    location: dto.location,
    relations: dto.relations,
    customInformation: dto.customInformation,
    imageFiles: mapMediaInfoFromDtoArray(dto.imageFiles ?? []),
    labels: dto.labels,
    isInOrderTracking: dto.isInOrderTracking,
    isSparepartCatalogAvailable: dto.isSparepartCatalogAvailable,
    sparepartCatalog: dto.sparepartCatalog
  };
};

export const mapAssetFromDtoArray = (array: Array<DtoAssetInterface>): Array<AssetModel> => {
  const result: Array<AssetModel> = [];

  array.forEach(dto => {
    result.push(mapAssetFromDto(dto));
  });

  return result;
};

export const mapAssetToDto = (model: AssetTypeModel): DtoAssetTypeRequestInterface => {
  return {
    businessUnit: model.businessUnit,
    technologyId: model.technologyId,
    assetProductCategory: model.assetProductCategory,
    defaultAssetName: model.defaultAssetName,
    translations: mapAssetTypeTranslationToDtoArray(model.translations ?? []),
    responsibleCompany: model.responsibleCompany,
    lockStatus: model.lockStatus,
    comment: model.comment,
    punchConfigType: model.punchConfigType
  };
};
